import { HEADER_HEIGHT } from '@src/constants';

export const headerStyles = {
	display: 'flex',
	flexFlow: 'row nowrap',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '16px 20px',
	position: 'fixed',
	top: 0,
	left: 'auto',
	right: 0,
	width: '100%',
	zIndex: 1201,
	bgcolor: 'backgrounds.default',
	borderBottom: `1px solid`,
	borderBottomColor: 'neutrals.primary',
	height: HEADER_HEIGHT,
};
